module.exports = __webpack_public_path__ + "static/img/material-pdf.57ff987.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/assets/material-pdf.png
// module id = aGF0
// module chunks = 36